import React, { useState } from 'react'
import { X, ChevronUp, ChevronDown, LayoutList, LayoutGrid, MapIcon } from 'lucide-react'

const Section = ({ title, initiallyOpen = false, hasActiveFilters = false, children }) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen || hasActiveFilters)

  return (
    <div className="border-b border-gray-200 last:border-0">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center justify-between w-full py-4 text-left">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-medium">{title}</h3>
          {hasActiveFilters && <span className="px-1.5 py-0.5 bg-blue-100 text-blue-600 rounded-full text-xs font-medium">Aktivní</span>}
        </div>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      {isOpen && <div className="pb-4">{children}</div>}
    </div>
  )
}

const SortViewModal = ({
  isOpen,
  onClose,
  // View
  view,
  onViewChange,
  // Sort
  selectedSort,
  onSortChange,
}) => {
  // Temporary state for changes
  const [tempView, setTempView] = useState(view)
  const [tempSort, setTempSort] = useState(selectedSort)

  // Reset temp state when modal opens
  React.useEffect(() => {
    if (isOpen) {
      setTempView(view)
      setTempSort(selectedSort)
    }
  }, [isOpen, view, selectedSort])

  if (!isOpen) return null

  const viewOptions = [
    { value: 'smallImages', label: 'Malý obrázek', icon: LayoutList },
    { value: 'largeImages', label: 'Velký obrázek', icon: LayoutGrid },
    { value: 'map', label: 'Mapa', icon: MapIcon },
    // { value: 'table', label: 'Tabulka', icon: TableIcon },
  ]

  const sortOptions = [
    { value: 'price-desc', label: 'Cena (nejvyšší)' },
    { value: 'price-asc', label: 'Cena (nejnižší)' },
    { value: 'ppm-desc', label: 'Cena za m² (nejvyšší)' },
    { value: 'ppm-asc', label: 'Cena za m² (nejnižší)' },
    { value: 'date-desc', label: 'Nejnovější' },
    { value: 'date-asc', label: 'Nejstarší' },
  ]

  const handleApplyChanges = () => {
    if (tempView !== view) {
      onViewChange(tempView)
    }
    if (tempSort !== selectedSort) {
      onSortChange(tempSort)
    }
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center sm:items-center sm:p-6 bg-black/25">
      <div className="relative w-full h-full bg-white sm:w-[480px] sm:h-auto sm:max-h-[90vh] sm:rounded-2xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 sm:rounded-t-2xl">
          <button onClick={onClose} className="p-2 -ml-2">
            <X size={24} />
          </button>
          <h2 className="text-lg font-medium">Zobrazení a řazení</h2>
          <div className="w-10" /> {/* Spacer for alignment */}
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="px-4">
            {/* View section */}
            <Section title="Zobrazení" initiallyOpen={true}>
              <div className="grid grid-cols-2 gap-2">
                {viewOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => setTempView(option.value)}
                    className={`px-4 py-3 border rounded-lg text-left transition-colors flex items-center gap-2 ${
                      tempView === option.value ? 'border-blue-600 bg-blue-50 text-blue-600' : 'border-gray-300 hover:border-gray-400'
                    }`}
                  >
                    <option.icon size={20} />
                    {option.label}
                  </button>
                ))}
              </div>
            </Section>

            {/* Sort section */}
            <Section title="Řazení" initiallyOpen={true} hasActiveFilters={tempSort !== 'date-desc'}>
              <div className="space-y-2">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => setTempSort(option.value)}
                    className={`w-full px-4 py-3 border rounded-lg text-left transition-colors ${
                      tempSort === option.value ? 'border-blue-600 bg-blue-50 text-blue-600' : 'border-gray-300 hover:border-gray-400'
                    }`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </Section>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 p-4 sm:rounded-b-2xl">
          <button onClick={handleApplyChanges} className="w-full bg-blue-600 text-white rounded-lg py-3 font-medium hover:bg-blue-700 transition-colors">
            Použít
          </button>
        </div>
      </div>
    </div>
  )
}

export default SortViewModal
